<template>
	<Modal @close="$emit('close')" size="small" class="upgrade-modal">
		<div class="container" v-if="tenant">
			<div class="row">
				<div class="col-12 text-center">
					<h3>Upgrade Subscription</h3>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-center horse-count">
					<h2>You currently have {{ horses.length }} / {{ tenant.max_horses }} Horses</h2>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<h4>Available Plans</h4>
					<div class="plan" v-for="(plan, i) in plans" :key="i" :class="{ disabled: (tenant.max_horses >= plan.max_horses) }">
						<input type="radio" name="plans" :id="plan.id" v-model="selectedPlanId" :value="plan.id" :disabled="tenant.max_horses >= plan.max_horses">
						<label :for="plan.id">{{ plan.title }}</label>
						<span v-if="plan.inc_multi_yard">(includes multi yard)</span>
						<span>&pound;{{ plan.price }} per month*</span>
					</div>
					<div class="multi-yard" :class="{ disabled: (tenant.has_multi_yard || selectedPlan && selectedPlan.inc_multi_yard) }">
						<input type="checkbox" id="my" v-model="multiYardSelected" :disabled="tenant.has_multi_yard == 1 || selectedPlan && selectedPlan.inc_multi_yard == 1">
						<label for="my">Multi-Yard</label>
						<span>&pound;{{ multiYardPrice }} per month*</span>
						<span v-if="tenant.has_multi_yard">(owned)</span>
						<span v-if="selectedPlan && selectedPlan.inc_multi_yard">(included in plan)</span>
					</div>
					<span>* Excludes VAT</span>
				</div>
			</div>
			<div class="row">
				<div class="col-12 pricing">
					<div class="price">
						<strong>Current Monthly Price</strong> <span>&pound;{{ tenant.monthly_payment }}</span>
					</div>
					<div class="price" v-if="newPrice != tenant.monthly_payment">
						<strong>New Monthly Price</strong> <span>&pound;{{ newPrice }}</span>
					</div>
				</div>
			</div>
			<div class="row" v-if="error">
				<div class="col-12 error">
					<span>No Change Selected</span>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-center">
					<button class="button-action button-action-delete" @click="upgrade">Upgrade Subscription</button>
				</div>
			</div>
		</div>
	</Modal>
</template>

<script>
import subscription from '../../lib/subscription'
import { mapState } from 'vuex'
import Modal from './../Modal.vue'

export default {
  components: {
		Modal
	},
	data() {
		return {
			multiYardPrice: 5,
			selectedPlanId: 0,
			multiYardSelected: false,
			error: false
		}
	},
	computed : {
		...mapState({
			horses: state => state.horses.list,
			plans : state => state.plans.list,
			tenant : state => state.account.tenant
		}),
		selectedPlan() {
			return this.plans.find(plan => {
				return plan.id == this.selectedPlanId
			})
		},
		newPrice() {
			let price = this.tenant.monthly_payment
			let plan = null

			this.error = false

			if(this.selectedPlan) {
				price = this.selectedPlan.price

				if(this.multiYardSelected) {
					price += this.selectedPlan.inc_multi_yard ? 0 : this.multiYardPrice
				}
			} else if(this.tenant.has_multi_yard != this.multiYardSelected) {
				price += this.multiYardPrice
			}

			return price
		}
	},
	methods: {
		upgrade() {
			if(this.newPrice == this.tenant.monthly_payment) {
				this.error = true
				return
			}

			this.$store.commit('app/setLoading', true)

			subscription.upgrade(this.selectedPlanId, this.multiYardSelected)
			.then((tenant) => {
				this.$store.commit('tenant/set', tenant)
				//force page to update and reload account
				location.reload()
			})
			.catch(err => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'An Error occurred, please try later',
					timeout: 3000
				})
			})
		}
	},
	mounted() {
		this.$store.commit('app/setLoading', true)

		this.multiYardSelected = this.tenant.has_multi_yard

		const horses = this.$store.dispatch('horses/getList')
		const plans = this.$store.dispatch('plans/getList')

		Promise.all([horses, plans])
		.then(() => {
			this.$store.commit('app/setLoading', false)
		})
		.catch(err => {
			this.$store.commit('app/setLoading', false)
			this.$store.dispatch('app/addAlert', {
				type: 'error',
				message: 'An Error occurred, please try later',
				timeout: 3000
			})
		})
	}
}
</script>

<style lang="scss">
	.upgrade-modal {
		.plan {
			margin-bottom: 5px;
		}
		label {
			display: inline;
		}
		.disabled {
			color: #D8D8D8;
		}
		.plan.disabled {
			display: none;
		}
		.pricing {
			padding-top: 20px;
			padding-bottom: 20px;
		}
		.price {
			padding: 5px 0;
			font-size: 20px;
		}
		.multi-yard {
			padding-top: 10px;
			padding-bottom: 10px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Account/Upgrade.vue